<script>
    /**
     * @author Evgeny Shevtsov, info@sitespring.ru
     * @homepage http://sitespring.ru
     * @licence Proprietary
     */

    import MainHeader from "../AppHeader";
    import MainFooter from "../AppFooter";

    export default {
        name: "Main",
        components: {
            MainHeader,
            MainFooter
        },
        computed: {
            defaultActive: vm => vm.$router.currentRoute.name
        }
    }
</script>


<template>
    <el-container id="viewport" direction="vertical">
        <main-header></main-header>
        <el-container>
            <el-aside width="250px">
                <h1 class="aside-header">
                    <el-icon class="el-icon-setting"></el-icon>
                    Настройки
                </h1>
                <el-menu :router="true" :default-active="defaultActive">
                    <el-menu-item index="settings" :route="{name:'settings'}">
                        Основные
                    </el-menu-item>
                    <el-menu-item index="settings-informers" :route="{name:'settings-informers'}">
                        Информеры
                    </el-menu-item>
                </el-menu>
            </el-aside>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
        <main-footer></main-footer>
    </el-container>
</template>


<style scoped lang="scss">
    @import "../../scss/element";

    .el-aside {
        border-right: 1px solid #eeeeee;
        padding-top: 20px;
    }

    .el-menu {
        border-right: none;

        &-item {
            &.is-active {
                font-weight: 700;
                background-color: $--dropdown-menuItem-hover-fill;
            }
        }
    }
</style>